import { combineReducers } from 'redux'
import { userReducer } from '../reducers/UserReducer'

export const rootReducer = combineReducers({
    userReducer
})